import { render } from "./UITooltip.vue?vue&type=template&id=18b77c02&scoped=true"
import script from "./UITooltip.vue?vue&type=script&lang=js"
export * from "./UITooltip.vue?vue&type=script&lang=js"

import "./UITooltip.vue?vue&type=style&index=0&id=18b77c02&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b77c02"]])

export default __exports__